import { Auth } from "aws-amplify";
import { googleUserLogin } from "../stepper_form/stepper.helper";
import { useDispatch, useSelector } from "react-redux";
import { setUserStatus } from "../../redux/action/user";
import { getTargetPath, saveTargetPath } from "../../utils/storage";
import ReactGA4 from "react-ga4";
import axios from "axios";

export const useSupportEmails = () => {
  const emails = "maulikd@jspinfotech.com";
  return emails;
};

export const customGoogleUserLogin = async (
  dispatch,
  uniqueReferredUserId,
  type
) => {
  try {
    const user = await Auth.currentAuthenticatedUser();

    // const referBy = useSelector((state) => state.userReducer.referBy);
    const referBy = localStorage.getItem("referBy");

    if (user.attributes.hasOwnProperty("sub")) {
      if (referBy !== null) {
        const payload = {
          email: user.attributes.email,
          registerTime: new Date(Date.now()).toUTCString(),
          lastLoginTime: new Date(Date.now()).toUTCString(),
          termsCondition: true,
          type: type,
          referBy: referBy,
          referTime: new Date(Date.now()).toUTCString(),
          uniqueReferredUserId,
        };
        await googleUserLogin(payload, dispatch, setUserStatus);
      } else {
        const payload = {
          email: user.attributes.email,
          registerTime: new Date(Date.now()).toUTCString(),
          lastLoginTime: new Date(Date.now()).toUTCString(),
          termsCondition: true,
          type: type,
          uniqueReferredUserId,
        };
        await googleUserLogin(payload, dispatch, setUserStatus);
      }
    }
  } catch (e) {
    console.log("e", e);
  }
};

const callBackUrl = (callBack, isParams, referralUrl) => {
  const isLocalhost = window.location.hostname === "localhost";

  if (callBack === "signIn") {
    if (isLocalhost) {
      if (isParams === referralUrl) {
        return "http://localhost:3000/endorse-expertise";
      } else {
        return `http://localhost:3000${isParams}`;
      }
    } else {
      if (isParams === referralUrl) {
        return "https://master.worthysalary.trueselfy.com/endorse-expertise";
      } else {
        return `https://master.worthysalary.trueselfy.com${isParams}`;
      }
    }
  } else {
    if (isLocalhost) {
      return "http://localhost:3000";
    } else {
      return `https://master.worthysalary.trueselfy.com`;
    }
  }
};

export const getRedirectSignInURL = () => {
  const NODE_ENV = process.env.REACT_APP_ENV;
  const urlSearchString = window.location.search;
  const params = new URLSearchParams(urlSearchString);
  const redirectLink = params.get("link");
  if (redirectLink === "/endorse-expertise") {
    saveTargetPath(redirectLink);
  }
  const isParams = getTargetPath();
  const referralUrl = "/endorse-expertise";
  switch (NODE_ENV) {
    case "dev":
      return callBackUrl("signIn", isParams, referralUrl);

    case "test":
      if (isParams === referralUrl) {
        return "https://test.worthysalary.trueselfy.com/endorse-expertise";
      } else {
        return `https://test.worthysalary.trueselfy.com${isParams}`;
      }
    case "prod":
      if (isParams === referralUrl) {
        return "https://worthysalary.trueselfy.com/endorse-expertise";
      } else {
        return `https://worthysalary.trueselfy.com${isParams}`;
      }
    default:
      if (isParams === referralUrl) {
        return "https://worthysalary.trueselfy.com/endorse-expertise";
      } else {
        return `https://worthysalary.trueselfy.com${isParams}`;
      }
  }
};

export const getRedirectSignOutURL = () => {
  const NODE_ENV = process.env.REACT_APP_ENV;
  switch (NODE_ENV) {
    case "dev":
      return callBackUrl("signOut");
    case "test":
      return "test.worthysalary.trueselfy.com";
    case "prod":
      return "https://worthysalary.trueselfy.com";
    default:
      return "https://worthysalary.trueselfy.com";
  }
};

export async function getCountryCode(setLoading) {
  try {
    // Get the user's public IP address
    setLoading(true);
    const ipResponse = await axios.get("https://api.ipify.org/?format=json");
    const ipAddress = ipResponse.data.ip;

    // Fetch location data and device info concurrently
    const locationResponse = await Promise.all([
      fetch(`https://ipapi.co/${ipAddress}/json/`).then((response) =>
        response.json()
      ),
    ]);

    // Check if location data is valid and set it
    if (!locationResponse?.error) {
      setLoading(false);

      // console.log(locationResponse, "locationResponse");
      return locationResponse;
    }
  } catch (error) {
    setLoading(false);

    console.log("Error:", error);
    // Handle specific errors here if needed
  }
}

export function GetUserLoginType() {
  const type = localStorage.getItem(
    `CognitoIdentityServiceProvider.${process.env.REACT_APP_COGNITO_CLIENT_ID}.LastAuthUser`
  );
  const userType = type?.split("_")[0];
  if (userType === "google") {
    return "google";
  } else if (userType === "linkedin") {
    return "linkedin";
  } else {
    return userType;
  }
}

const imageExists = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
};

const getIconByName = async (skillName) => {
  const svgIconPath = `${process.env.PUBLIC_URL}/assets/images/icons/${skillName}.svg`;
  const pngIconPath = `${process.env.PUBLIC_URL}/assets/images/icons/${skillName}.png`;
  const darkIconPath = `${process.env.PUBLIC_URL}/assets/images/dark-icons/${skillName}.svg`;

  if (await imageExists(svgIconPath)) {
    return svgIconPath;
  } else if (await imageExists(pngIconPath)) {
    return pngIconPath;
  } else if (await imageExists(darkIconPath)) {
    return darkIconPath;
  }
  return null;
};

export const getIconBySkillName = (imgPath, skillName) => {
  return imgPath && imgPath.trim() !== ""
    ? `../../../assets/images/${imgPath}`
    : null;
};

export function removeEmptyKeysAndObjects(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        obj[key] === "" ||
        obj[key] === "No" ||
        key === "userlocation" ||
        key === "resultTime" ||
        key === "lastStepper" ||
        key === "deviceinfo" ||
        key === "location" ||
        key === "typeOfCompany" ||
        key === "pdfText" ||
        key === "currentCompany" ||
        key === "secondarySkill" ||
        key === "phone" ||
        key === "linkedInUrl" ||
        key === "githubUrl" ||
        key === "suggestedExperience" ||
        key === "suggestedSkills" ||
        key === "relevanceResult" ||
        key === "jobHopperIndex" ||
        key === "userRefId" ||
        key === "fileName" ||
        key === "fileUrl" ||
        key === "payloadType" ||
        key === "expInt" ||
        key === "uuid" ||
        key === "selfAttested"
      ) {
        delete obj[key];
      } else if (key === "experience") {
        let experienceValue = parseFloat(obj[key]);
        if (!isNaN(experienceValue)) {
          let years = Math.floor(experienceValue / 12);
          let months = experienceValue % 12;
          obj[key] = `${years} year${years !== 1 ? "s" : ""} ${months} month${
            months !== 1 ? "s" : ""
          }`.trim();
        }
      } else if (typeof obj[key] === "object") {
        if (Array.isArray(obj[key])) {
          if (obj[key].length === 0) {
            delete obj[key];
          } else {
            obj[key].forEach((item) => {
              if (item && typeof item === "object" && "type" in item) {
                delete item.type;
              }
            });
          }
        } else {
          if (Object.keys(obj[key]).length === 0) {
            delete obj[key];
          }
        }
      }
    }
  }
  return obj;
}
